module.exports = __webpack_public_path__ + "fonts/lato-light-greek.9b8b278.woff2";